// extracted by mini-css-extract-plugin
export default {"markdown":"QuestionText_markdown__Pij98","question":"QuestionText_question__o6pb5","author":"QuestionText_author__sSZCs","link":"QuestionText_link__LfVcc"};